import { createApp } from 'vue'
import App from './App.vue'

import router from './router';
import storiumShopLibrary from '@kristjan87/storium-shop-library';

import PrimeVue from 'primevue/config';
import sagaBlue from '@primevue/themes/aura'
import 'primeicons/primeicons.css';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import translations from './translation';
// import Notifications from 'vue-notification'
// import velocity      from 'velocity-animate'

// import VueSimpleAlert from "vue-simple-alert";

// Vue.use(VueSimpleAlert)

// Vue.use(Notifications, { velocity })
const app = createApp(App)
app.config.globalProperties.$t = (key) => {
    return translations.translate(key);
};

app.use(PrimeVue, {
    theme: {
        preset: sagaBlue,
        options: {
            darkModeSelector: '.my-app-dark'
        }
    }
});
app.use(storiumShopLibrary);
app.use(router)
app.use(ConfirmationService)
app.use(ToastService)

app.config.globalProperties.$fetchIp = process.env.VUE_APP_MAIN_URL;
app.config.globalProperties.$frontIp = process.env.VUE_APP_FRONT_URL;

app.mount('#app')
